var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.3 27.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #e88711;\n      }\n\n      .st1 {\n        fill: #ffaa16;\n      }\n\n      .st2 {\n        fill: #ffd83b;\n      }\n\n      .st3 {\n        fill: #f39e09;\n      }\n\n      .st4 {\n        fill: url(#Degradado_sin_nombre);\n      }\n\n      .st5 {\n        fill: #e88102;\n        fill-opacity: .5;\n      }\n\n      .st6 {\n        fill: #f19018;\n      }\n\n      .st7 {\n        fill: #ffe77e;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    "data-name": "Degradado sin nombre",
    x1: 12.5,
    y1: 31.8,
    x2: 12.5,
    y2: 4.8,
    gradientTransform: "translate(0 32) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffbf1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc536"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M27.1,13.7c0,7.5-5.5,13.5-12.4,13.5s-9.8-.6-9.8-13.5S7.9.2,14.8.2s12.4,6,12.4,13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12.5,27.2C5.7,27.2.1,21.1.1,13.7S5.7.2,12.5.2s12.4,6,12.4,13.5-5.5,13.5-12.4,13.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.4,10.1c1.8,4.8-.4,10.3-4.8,12.3-4.4,1.9-9.5-.4-11.3-5.3-1.8-4.8.4-10.3,4.8-12.3,4.4-1.9,9.5.4,11.3,5.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.9,5.5c4.4-1.9,7.2,0,8.4,1.3-2.6,1.6-9,8.5-10.4,14.6-6.1-5.6-2.5-14,1.9-15.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M9.5,22.6c-1.8-1-3.2-2.7-4.1-4.9-1.8-4.8.4-10.3,4.8-12.3,2-.9,4.1-.9,6-.2-2.2-1.2-4.8-1.4-7.2-.4-4.4,1.9-6.6,7.4-4.8,12.3,1,2.7,2.9,4.6,5.2,5.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.1,12.1c.3-.3,0-.9-.4-.9h-4.9c-.4,0-.6-.4-.5-.7l1.8-4.5c.2-.6-1.6-1-2-.5l-6.3,9.4c-.3.3,0,.9.4.9h4.9c.4,0,.6.4.5.7l-3,4.8c-.2.6,1.6.7,2,.2l7.5-9.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.8,12.1c.3-.3,0-.9-.4-.9h-4.9c-.4,0-.6-.4-.5-.7l1.8-4.5c.2-.6-.5-1-.8-.5l-7.5,9.4c-.3.3,0,.9.4.9h4.9c.4,0,.6.4.5.7l-1.8,4.5c-.2.6.5,1,.8.5l7.5-9.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M15.1,2c0-.2,0-.5-.3-.5-1.4-.2-2.8-.2-4.1,0-1.5.3-2.9.9-4.2,1.8-1.3.9-2.4,2-3.2,3.3-.8,1.2-1.3,2.5-1.7,3.9,0,.2,0,.5.3.5s.4-.1.5-.3c.3-1.3.8-2.5,1.5-3.6.8-1.2,1.8-2.3,3-3.1,1.2-.8,2.5-1.4,3.9-1.7,1.2-.3,2.5-.3,3.8,0,.2,0,.5-.1.5-.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.5,25.4c0,.2.2.4.5.4,2.5-.3,4.9-1.5,6.8-3.4.2-.2.2-.4,0-.6-.2-.2-.4-.2-.6,0-1.7,1.7-3.9,2.8-6.2,3.1-.2,0-.4.2-.4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.88d26dcd7a516aa45891e4f465ae26fa.svg";
export { ForwardRef as ReactComponent };